import { ReactElement, CSSProperties } from 'react';
import * as css from "../styles/css.module.scss";
import cn from "classnames";


export interface ExecutiveSummaryBannerProps {
    className?: string;
    bannerImg?: string | null;
    bannerImgPosition?: CSSProperties["backgroundPosition"] | null;
    logoImg?: string | null;
    logoSize?: number | null;
    clientName: string | undefined;
    propertyName: string | undefined;
    budgetYear: number | undefined;
    colorPrimary: string;
    isCollapsed: boolean;
}

export default function ExecutiveSummaryBanner({className, bannerImg, bannerImgPosition, logoImg, logoSize: logoSize, propertyName, budgetYear, clientName, colorPrimary, isCollapsed}: ExecutiveSummaryBannerProps): ReactElement {
    const logoStyleObject: {width?: string} = {};

    if (logoSize != null) {
        logoStyleObject.width = `${logoSize}px`;
    }

    return (
        <div
            className={cn(className, css.banner, (isCollapsed && css.bannerSmall))}
            style={{
                backgroundImage: `url('${bannerImg}')`,
                backgroundPosition: bannerImgPosition ?? "center",
            }}
        >
            <div className={css.bannerColorOverlay} style={{backgroundColor: colorPrimary}}></div>
            <div className={css.bannerInner}>
                <h1>{propertyName}</h1>
                <span>{budgetYear} Operating Budget - Presented by {clientName}</span>
                {
                    logoImg && logoImg != "" &&
                    <img src={logoImg} className={css.bannerLogo} style={logoStyleObject} />
                }
            </div>
        </div>
    );
}
